import { useCallback } from 'react';

export const useCopyToClipboard = () => {
  return useCallback((textToCopy: string, callback = () => {}) => {
    if (!textToCopy) return;
    navigator.clipboard.writeText(textToCopy);
    callback();
  }, []);
};
